import axios from 'axios';

export const BASE_URL = 'https://youtube-v31.p.rapidapi.com';
export const options = {
  params: {
    maxResults: 50,
  },
  headers: {
    'X-RapidAPI-Key': 'fe81153977mshe1a364d39d2de04p1023fejsn1ca733b65a8d',
    'X-RapidAPI-Host': 'youtube-v31.p.rapidapi.com',
  },
};


  export const axiosGetReq = async (url) => {
    const res = await axios.get(`${BASE_URL}/${url}`, options);
    return res.data;
    console.log(res.data)
  };
